import type { PromptResolve } from '@ur-solutions/react-components'
import { useForm, useTranslate } from '@ur-solutions/react-hooks'
import { RegularModal, Select } from '@/components_deprecated'
import { Field, Form } from '@/modules/companies'
import React from 'react'
import {
  ExportFormat,
  USER_EXPORT_STATUS,
  type UserExportStatusType,
} from '@/modules/exports'
import { Combobox } from '@/components/combobox'

interface ExportActivitiesModalProps {
  onSubmit: PromptResolve<{
    exportFormat: ExportFormat
    statusType: UserExportStatusType
  } | null>
}

interface ExportEquipmentFormValues {
  exportFormat: ExportFormat
  statusType: UserExportStatusType
}

export const ExportEquipmentModal: React.FC<ExportActivitiesModalProps> = ({
  onSubmit,
}) => {
  const translations = useTranslate({
    export: 'common.export',
    exportFormat: 'common.export-format',
    status: 'common.status',
    all: 'common.all',
    active: 'common.active',
    deactivated: 'common.deactivated',
    excel: 'common.excel',
    pdf: 'common.pdf',
  })

  const {
    formValues: form,
    updateForm,
    submitHandler: submit,
  } = useForm<ExportEquipmentFormValues>({
    values: {
      exportFormat: ExportFormat.PDF,
      statusType: USER_EXPORT_STATUS.ALL,
    },
    config: {
      storage: {
        storeFormState: true,
        retrieveFormStateOnMount: true,
        storeFormStateName: 'Export-equipments-form',
        transformValues: {
          exportFormat: value => value as ExportFormat,
          statusType: value => value as UserExportStatusType,
        },
      },
    },
  })

  const formatOptions = [
    {
      value: ExportFormat.PDF,
      label: translations.pdf,
    },
    {
      value: ExportFormat.EXCEL,
      label: translations.excel,
    },
  ]

  return (
    <RegularModal
      title={translations.export}
      width="400px"
      submitText={translations.export}
      onCancel={() => onSubmit(null)}
      onSubmit={submit(onSubmit)}
    >
      <Form>
        <Field>
          <label>{translations.exportFormat}</label>
          <Select
            value={form.exportFormat}
            options={formatOptions}
            fullWidth
            height="3.875rem"
            onChange={value =>
              updateForm({
                exportFormat: value ?? ExportFormat.PDF,
              })
            }
          />
        </Field>

        <Field>
          <label>{translations.status}</label>
          <Combobox
            mode="single"
            value={form.statusType}
            items={[
              {
                label: translations.all,
                value: USER_EXPORT_STATUS.ALL,
              },
              {
                label: translations.active,
                value: USER_EXPORT_STATUS.ACTIVE,
              },
              {
                label: translations.deactivated,
                value: USER_EXPORT_STATUS.INACTIVE,
              },
            ]}
            onChange={statusType => updateForm({ statusType })}
            noSearch
          />
        </Field>
      </Form>
    </RegularModal>
  )
}
